// src/redux/carApi.js
import { apiSlice } from "./apiSlice";

export const carApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        postCar: build.mutation({
            query: (body) => ({
                url: "/api/user/car/v1",
                method: "post",
                data: body,
                headers: { token: true },
            }),
        }),
        putCar: build.mutation({
            query: ({ carId, body }) => ({
                url: `/api/user/car/v1/${carId}`,
                method: "put",
                data: body,
                headers: { token: true },
            }),
        }),
        searchCar: build.query({
            query: ({ car_number, owner_name }) => ({
                url: "/api/user/car/v1/search",
                method: "get",
                params: { car_number, owner_name },
                headers: { token: true },
            }),
        }),
        searchCarByNumber: build.query({
            query: ({ car_number }) => ({
                url: "/api/user/car/v1/car_number",
                method: "get",
                params: { car_number },
                headers: { token: true },
            }),
        }),
        getAllCars: build.query({
            query: (params) => ({
                url: "/api/user/car/v1",
                method: "get",
                params,
                headers: { token: true },
            }),
        }),

        // 1) 차량 상세조회 (GET /api/user/car/v1/{carId})
        getCarById: build.query({
            query: (carId) => ({
                url: `/api/user/car/v1/${carId}`,
                method: "get",
                headers: { token: true },
            }),
        }),

        // 2) 차량 대량 등록 (POST /api/user/car/v1/rent_corp/{rentCorpId}/bulk)
        postCarBulkFile: build.mutation({
            query: ({ rentCorpId, body }) => ({
                url: `/api/user/car/v1/rent_corp/${rentCorpId}/bulk`,
                method: "post",
                data: body, // FormData 안에 excel_file, zip_file
                headers: { token: true, "Content-Type": "multipart/form-data" },
            }),
        }),

        // 3) 차량 대량 업로드 (POST /api/user/car/v1/bulk/{carBulkId})
        postCarBulk: build.mutation({
            query: ({ carBulkId }) => ({
                url: `/api/user/car/v1/bulk/${carBulkId}`,
                method: "post",
                headers: { token: true },
            }),
        }),

        deleteCar: build.mutation({
            query: (carId) => ({
                url: `/api/user/car/v1/${carId}`,
                method: "delete",
                headers: { token: true },
            }),
        }),
    }),
});

export const {
    usePostCarMutation,
    usePutCarMutation,
    useLazySearchCarQuery,
    useLazySearchCarByNumberQuery,
    useGetAllCarsQuery,
    useGetCarByIdQuery,
    useLazyGetCarByIdQuery,
    usePostCarBulkFileMutation,
    usePostCarBulkMutation,
    useDeleteCarMutation,
} = carApi;
